import { Content } from "@robe/core";
import { useData } from "./useData";

/**
 * @returns array of content singletons fetched in the `contentSingletons` field
 */
export const useContentSingletons = <TSource extends Content[]>() => {
  const { contentSingletons } = useData<Content, TSource, Content[]>();

  return contentSingletons;
};
